





import Vue from 'vue';
import { types } from '@/modules/servis/zakazka/store/types';
import { ServicePackage } from '@/modules/servis/zakazka/ServicePackage';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { TABLE_DATA, START_LOADING, END_LOADING } from '@/main/store/listEditTypes';

import { store } from '../../store/edit';
import { PRACOVNI_POZICE, ZAKAZKA_ND } from '../../constants';
import { apiProvider } from '../../api';


export default Vue.extend({
	name: 'MicroPackageSelect',
	components: {
		PackageSelect: ServicePackage.components.Select,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.SERVICE_PACKAGE}`,
			};
		},
		vozidloFilter(): object {
			return {
				VozidloId: this.VozidloId,
			};
		},
	},
	methods: {
		async clear() {
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			const SP = await (apiProvider.deletePackageLabor(this.ZakazkaId!));
			await (apiProvider.deletePackageParts(this.ZakazkaId!));
			await (apiProvider.deletePackageReserveParts(this.ZakazkaId!));
			if (this.ZakazkaId! > 0) {
				this.ZakazkaId = SP.data;
			}
			this.$store.dispatch(`${this.storeUri}/${PRACOVNI_POZICE}_${TABLE_DATA}`, { filter: { ZakazkaId: this.ZakazkaId } });
			this.$store.dispatch(`${this.storeUri}/${ZAKAZKA_ND}_${TABLE_DATA}`, { filter: { ZakazkaId: this.ZakazkaId } });
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
	},
});
